/* eslint-disable no-new */
export default {
    copyFiscalAddress({ commit }, val) {
        new Promise(resolve => {
            commit('SET_COPY_FISCAL_ADDRESS', val);
            resolve();
        });
    }
};
